import { gql } from '@apollo/client';
import { Keyword } from '@app/utils/types';

export type Rating = {
  rating: {
    documentId: string;
    title: string;
    description: string;
    keywords?: Keyword[];
  };
};

export const getRating = gql`
  query GetRating($ratingId: ID!) {
    rating(documentId: $ratingId) {
      documentId
      title
      description
      keywords {
        keyword
      }
    }
  }
`;
